// Índice de documentos de la categoría: Facebook
import conectar_facebook_messenger from './conectar-facebook-messenger.js';

const facebookDocs = [
  conectar_facebook_messenger,
];

export default facebookDocs;
